module.exports = __webpack_public_path__ + "img/BRUXA.f9422735.jpg";